
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".184","width":"24.672","height":"24.672","rx":"2.5","fill":"#191919","fill-opacity":".6"}}),_c('path',{attrs:{"d":"M12.827 7.965c-.316 0-.587.113-.805.331a1.153 1.153 0 00-.331.843c0 .264.082.475.24.64.159.166.377.249.648.249.308 0 .572-.113.798-.346.226-.226.338-.512.338-.844 0-.27-.082-.482-.24-.64-.166-.158-.377-.233-.648-.233zM13.317 10.57h-1.634a.121.121 0 00-.098.045.18.18 0 00-.053.098l-.707 5.836c-.008.038 0 .075.023.098.022.03.052.045.097.045h1.634a.121.121 0 00.098-.045.18.18 0 00.052-.098l.708-5.836c.008-.037 0-.075-.023-.098-.022-.03-.052-.045-.097-.045z","fill":"#E7E5EC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.632 7.83c1.965-2.41 5.39-3.33 8.296-2.222 2.875 1.1 4.742 3.848 4.787 6.913-.053 3.494-2.537 6.633-6.022 7.258-3.019.543-6.128-.828-7.708-3.478-1.589-2.658-1.295-6.092.647-8.472zm.828 8.681c1.679 2.041 4.517 2.824 7.008 1.936v-.008c2.5-.888 4.125-3.298 4.163-5.926-.045-2.997-2.16-5.618-5.134-6.19-2.567-.49-5.239.73-6.571 2.967-1.34 2.244-1.137 5.196.534 7.222z","fill":"#E7E5EC"}})])
          )
        }
      }
    